import { render, staticRenderFns } from "./DictionaryTable.vue?vue&type=template&id=b7ea145c&scoped=true&"
import script from "./DictionaryTable.vue?vue&type=script&lang=js&"
export * from "./DictionaryTable.vue?vue&type=script&lang=js&"
import style0 from "./DictionaryTable.vue?vue&type=style&index=0&id=b7ea145c&scoped=true&lang=scss&"
import style1 from "./DictionaryTable.vue?vue&type=style&index=1&id=b7ea145c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7ea145c",
  null
  
)

export default component.exports